/* eslint-disable arrow-body-style */
import { mapActions, mapState } from 'vuex';
import { formMixin, validators } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  data() {
    return {
      fields: {
        reason: null,
        message: '',
      },
      files: [],
    };
  },
  validations: {
    fields: {
      reason: validators.required,
      message: validators.message,
    },
  },
  computed: {
    ...mapState('support', ['reportReasons']),
    ...mapState('user', ['watchedUserDetails']),
    isUploadEnabled() {
      // return !(this.isIos && this.isStandalone);
      return false;
    },
    messagePlaceholder() {
      return (this.fields.message) ? '' : 'Message';
    },
    messageRequired() {
      return !this.fields.message;
    },
    reasonOptions() {
      return this.reportReasons.map((item) => {
        return {
          label: item.reason,
          value: item.reasonId,
        };
      });
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('support', ['getReportUserReasons', 'reportUser']),
    ...mapActions('notifications', ['setSuccessSideNotification']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        this.loaderAdd(document.body);
        // const formData = new FormData();
        // formData.append('subject', this.fields.subject.value);
        // formData.append('description', this.fields.message);
        //
        //
        // this.files.forEach((file) => {
        //   formData.append('uploadedFile', file);
        // });
        const payload = {
          userName: this.watchedUserDetails.userName,
          description: this.fields.message,
          reasonId: this.fields.reason.value,
          pageUrl: window.location.href,
        };
        this.reportUser(payload)
          .then(() => {
            this.loaderRemove(document.body);
            this.setSuccessSideNotification('Report received.<br> Thank you.');
            this.setCurrentSmallPopup();
          })
          .catch((error) => {
            this.loaderRemove(document.body);
            this.formHandleErrors(error);
          });
      }
    },
    onUpload() {
      this.$refs.fileinput.click();
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve({
          name: file.name,
          file: reader.result,
        });
        reader.onerror = error => reject(error);
      });
    },
    onChange() {
      const files = this.$refs.fileinput.files;
      if (files.length) {
        this.files = [...this.files, ...files];
      }
    },
    fileRemove(index) {
      this.files = [
        ...this.files.slice(0, index),
        ...this.files.slice(index + 1),
      ];
    },
  },
  created() {
    this.getReportUserReasons();
  },
};



// WEBPACK FOOTER //
// ./src/components/social/user-report/user-report.js